import { _Componentes_WebApiCalls_PostBlob } from "../ComponentesGlobales/WebApiCalls";

export const FORMATOS_EXPORTACION = Object.freeze(["pdf", "xlsx", "csv"]);

const normalizarFormato = (formato) => String(formato || "").trim().toLowerCase();

export const formatearFechaExportacion = (valor) => {
  if (/^\d{4}-\d{2}-\d{2}$/.test(String(valor || ""))) return String(valor);
  const fecha = new Date(valor);
  if (Number.isNaN(fecha.getTime())) return "";
  fecha.setMinutes(fecha.getMinutes() - fecha.getTimezoneOffset());
  return fecha.toISOString().slice(0, 10);
};

export const construirEndpointExportacion = (endpoint, formato) => {
  const formatoNormalizado = normalizarFormato(formato);
  if (!FORMATOS_EXPORTACION.includes(formatoNormalizado)) {
    throw new Error("El formato de exportación no es válido.");
  }
  const ruta = String(endpoint || "").replace(/^\/+|\/+$/g, "");
  if (!ruta) throw new Error("El reporte solicitado no es válido.");
  return `${ruta}/Exportar?formato=${encodeURIComponent(formatoNormalizado)}`;
};

const fechaValida = (valor) => /^\d{4}-\d{2}-\d{2}$/.test(String(valor || ""));

export const validarFiltrosExportacion = (filtros = {}, { ranking = false } = {}) => {
  if ("FechaDesde" in filtros || "FechaHasta" in filtros) {
    if (!fechaValida(filtros.FechaDesde) || !fechaValida(filtros.FechaHasta)) {
      throw new Error("Debe indicar fechas válidas.");
    }
    const desde = new Date(`${filtros.FechaDesde}T00:00:00Z`);
    const hasta = new Date(`${filtros.FechaHasta}T00:00:00Z`);
    const dias = Math.floor((hasta - desde) / 86400000) + 1;
    if (dias <= 0) throw new Error("FechaHasta no puede ser anterior a FechaDesde.");
    if (dias > 366) throw new Error("El rango no puede superar 366 días.");
  }
  if (ranking) {
    const tamano = Number(filtros.TamanoPagina);
    if (!Number.isInteger(tamano) || tamano < 1 || tamano > 200) {
      throw new Error("TamanoPagina debe estar entre 1 y 200.");
    }
  }
  return true;
};

export const extraerNombreArchivo = (contentDisposition, alternativo = "reporte") => {
  const encabezado = String(contentDisposition || "");
  const extendido = encabezado.match(/filename\*\s*=\s*(?:UTF-8'')?([^;]+)/i);
  if (extendido) {
    const valor = extendido[1].trim().replace(/^"|"$/g, "");
    try { return decodeURIComponent(valor); } catch { return valor; }
  }
  const simple = encabezado.match(/filename\s*=\s*(?:"([^"]+)"|([^;]+))/i);
  return (simple?.[1] || simple?.[2] || alternativo).trim();
};

export const descargarBlob = ({ blob, contentDisposition, nombreAlternativo, entorno = globalThis }) => {
  const nombre = extraerNombreArchivo(contentDisposition, nombreAlternativo);
  const url = entorno.URL.createObjectURL(blob);
  const enlace = entorno.document.createElement("a");
  enlace.href = url;
  enlace.download = nombre;
  enlace.style.display = "none";
  entorno.document.body?.appendChild(enlace);
  try {
    enlace.click();
  } finally {
    enlace.remove?.();
    entorno.URL.revokeObjectURL(url);
  }
  return nombre;
};

export const exportReport = async ({ endpoint, format, filters, ranking = false, entorno = globalThis }) => {
  validarFiltrosExportacion(filters, { ranking });
  const formato = normalizarFormato(format);
  const ruta = construirEndpointExportacion(endpoint, formato);
  const respuesta = await _Componentes_WebApiCalls_PostBlob(ruta, filters);
  if (respuesta.error) throw new Error(respuesta.error);
  const nombreAlternativo = `reporte.${formato}`;
  const filename = descargarBlob({
    blob: respuesta.data,
    contentDisposition: respuesta.contentDisposition,
    nombreAlternativo,
    entorno,
  });
  return { filename, format: formato };
};
